import { getOrdinalSuffix } from '@Helpers';
import { parse } from 'date-fns';
import { isMatch } from 'lodash';

import { DrawdownFlexibility } from '@FormModels/eligibility/loanPreferences';
import { extractLeadingNumber } from '@Shared/helpers/string';

export const getIsMoveToRates = (values: any) => {
    if (values?.moreThan10PercentNoFeesOverpaymentPlanned) {
        return true;
    }

    return isMatch(values, {
        monthlyOverpaymentsPlanned: 'false',
    });
};

export const getYearItems = (term: number) => {
    const array = [];

    for (let i = 0; i < term - 1; i++) {
        const item = {
            label: `${getOrdinalSuffix(i + 1)} year`,
            value: `${getOrdinalSuffix(i + 1)} year`,
        };

        array.push(item);
    }

    return array;
};

const getFutureDate = (date: Date, yearsToAdd: number): Date => {
    const targetYear = date.getFullYear() + Number(yearsToAdd);
    date.setFullYear(targetYear);

    return date;
};

export const getIsRetireBeforeRedeem = (
    dateOfBirth: string,
    fullEarlyRepaymentYear: string,
    estimatedRetirementAge: number,
) => {
    const parsedDateOfBirth = parse(dateOfBirth, 'dd/MM/yyyy', new Date());

    const retirementDate = getFutureDate(
        parsedDateOfBirth,
        estimatedRetirementAge,
    );

    const formattedFullEarlyRepaymentYear = extractLeadingNumber(
        fullEarlyRepaymentYear,
    );

    if (!formattedFullEarlyRepaymentYear) {
        return false;
    }

    const redeemDate = getFutureDate(
        new Date(),
        formattedFullEarlyRepaymentYear,
    );

    return retirementDate < redeemDate;
};

export const mixpanelValuesConverter = (formValue: string) => {
    switch (formValue) {
        case 'true':
            return 'Yes';
        case 'false':
            return 'No';
        case DrawdownFlexibility.ALL_AT_ONCE:
            return 'All at once';
        case DrawdownFlexibility.AS_NEEDED:
            return 'As needed';
        default:
            return extractLeadingNumber(formValue);
    }
};
